// Quiz Redux Duck
import { submitQuizApi, getQuizFieldsApi, submitAssessmentCompletedApi, getAssessmentResultApi } from '../util/api';

export const SUBMIT_QUIZ_REQUEST = 'app/quiz/SUBMIT_QUIZ_REQUEST';
export const SUBMIT_QUIZ_SUCCESS = 'app/quiz/SUBMIT_QUIZ_SUCCESS';
export const SUBMIT_QUIZ_ERROR = 'app/quiz/SUBMIT_QUIZ_ERROR';
export const FETCH_QUIZ_FIELDS_REQUEST = 'app/quiz/FETCH_QUIZ_FIELDS_REQUEST';
export const FETCH_QUIZ_FIELDS_SUCCESS = 'app/quiz/FETCH_QUIZ_FIELDS_SUCCESS';
export const FETCH_QUIZ_FIELDS_ERROR = 'app/quiz/FETCH_QUIZ_FIELDS_ERROR';
export const SUBMIT_ASSESSMENT_COMPLETED_REQUEST = 'app/quiz/SUBMIT_ASSESSMENT_COMPLETED_REQUEST';
export const SUBMIT_ASSESSMENT_COMPLETED_SUCCESS = 'app/quiz/SUBMIT_ASSESSMENT_COMPLETED_SUCCESS';
export const SUBMIT_ASSESSMENT_COMPLETED_ERROR = 'app/quiz/SUBMIT_ASSESSMENT_COMPLETED_ERROR';
export const FETCH_ASSESSMENT_RESULT_REQUEST = 'app/quiz/FETCH_ASSESSMENT_RESULT_REQUEST';
export const FETCH_ASSESSMENT_RESULT_SUCCESS = 'app/quiz/FETCH_ASSESSMENT_RESULT_SUCCESS';
export const FETCH_ASSESSMENT_RESULT_ERROR = 'app/quiz/FETCH_ASSESSMENT_RESULT_ERROR';

export const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  error: null,
  isFetchingFields: false,
  quizFields: null,
  fetchFieldsError: null,
  isSubmittingCompleted: false,
  submitCompletedSuccess: false,
  submitCompletedError: null,
  isFetchingResult: false,
  assessmentResult: null,
  fetchResultError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SUBMIT_QUIZ_REQUEST:
      return { ...state, isSubmitting: true, error: null, submitSuccess: false };
    case SUBMIT_QUIZ_SUCCESS:
      return { ...state, isSubmitting: false, submitSuccess: true, error: null };
    case SUBMIT_QUIZ_ERROR:
      return { ...state, isSubmitting: false, submitSuccess: false, error: payload };
    case FETCH_QUIZ_FIELDS_REQUEST:
      return { ...state, isFetchingFields: true, fetchFieldsError: null };
    case FETCH_QUIZ_FIELDS_SUCCESS:
      return { ...state, isFetchingFields: false, quizFields: payload, fetchFieldsError: null };
    case FETCH_QUIZ_FIELDS_ERROR:
      return { ...state, isFetchingFields: false, fetchFieldsError: payload };
    case SUBMIT_ASSESSMENT_COMPLETED_REQUEST:
      return { ...state, isSubmittingCompleted: true, submitCompletedError: null, submitCompletedSuccess: false };
    case SUBMIT_ASSESSMENT_COMPLETED_SUCCESS:
      return { ...state, isSubmittingCompleted: false, submitCompletedSuccess: true, submitCompletedError: null };
    case SUBMIT_ASSESSMENT_COMPLETED_ERROR:
      return { ...state, isSubmittingCompleted: false, submitCompletedSuccess: false, submitCompletedError: payload };
    case FETCH_ASSESSMENT_RESULT_REQUEST:
      return { ...state, isFetchingResult: true, fetchResultError: null };
    case FETCH_ASSESSMENT_RESULT_SUCCESS:
      return { ...state, isFetchingResult: false, assessmentResult: payload, fetchResultError: null };
    case FETCH_ASSESSMENT_RESULT_ERROR:
      return { ...state, isFetchingResult: false, assessmentResult: null, fetchResultError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //
export const submitQuizRequest = () => ({
  type: SUBMIT_QUIZ_REQUEST,
});

export const submitQuizSuccess = () => ({
  type: SUBMIT_QUIZ_SUCCESS,
});

export const submitQuizError = error => ({
  type: SUBMIT_QUIZ_ERROR,
  payload: error,
});

export const fetchQuizFieldsRequest = () => ({
  type: FETCH_QUIZ_FIELDS_REQUEST,
});

export const fetchQuizFieldsSuccess = payload => ({
  type: FETCH_QUIZ_FIELDS_SUCCESS,
  payload,
});

export const fetchQuizFieldsError = error => ({
  type: FETCH_QUIZ_FIELDS_ERROR,
  payload: error,
});

export const submitAssessmentCompletedRequest = () => ({
  type: SUBMIT_ASSESSMENT_COMPLETED_REQUEST,
});

export const submitAssessmentCompletedSuccess = () => ({
  type: SUBMIT_ASSESSMENT_COMPLETED_SUCCESS,
});

export const submitAssessmentCompletedError = error => ({
  type: SUBMIT_ASSESSMENT_COMPLETED_ERROR,
  payload: error,
});

export const fetchAssessmentResultRequest = () => ({
  type: FETCH_ASSESSMENT_RESULT_REQUEST,
});

export const fetchAssessmentResultSuccess = payload => ({
  type: FETCH_ASSESSMENT_RESULT_SUCCESS,
  payload,
});

export const fetchAssessmentResultError = error => ({
  type: FETCH_ASSESSMENT_RESULT_ERROR,
  payload: error,
});

// ================ Thunks ================ //
export const submitQuiz = (params = {}) => async (dispatch, getState) => {
  dispatch(submitQuizRequest());
  try {
    const result = await submitQuizApi(params);
    dispatch(submitQuizSuccess());
    return result;
  } catch (error) {
    console.error('Error submitting quiz:', error);
    dispatch(submitQuizError(error.message || 'Failed to submit quiz'));
    throw error;
  }
};

export const fetchQuizFields = (params = {}) => async (dispatch, getState) => {
  dispatch(fetchQuizFieldsRequest());
  try {
    const result = await getQuizFieldsApi(params);
    dispatch(fetchQuizFieldsSuccess(result));
    return result;
  } catch (error) {
    console.error('Error fetching quiz fields:', error);
    dispatch(fetchQuizFieldsError(error.message || 'Failed to fetch quiz fields'));
    throw error;
  }
};

export const submitAssessmentCompleted = (params = {}) => async (dispatch, getState) => {
  dispatch(submitAssessmentCompletedRequest());
  try {
    const result = await submitAssessmentCompletedApi(params);
    dispatch(submitAssessmentCompletedSuccess());
    return result;
  } catch (error) {
    console.error('Error submitting assessment completed:', error);
    dispatch(submitAssessmentCompletedError(error.message || 'Failed to submit assessment completed'));
    throw error;
  }
};

export const fetchAssessmentResult = (params = {}) => async (dispatch, getState) => {
  dispatch(fetchAssessmentResultRequest());
  try {
    const result = await getAssessmentResultApi(params);
    dispatch(fetchAssessmentResultSuccess(result));
    return result;
  } catch (error) {
    console.error('Error fetching assessment result:', error);
    dispatch(fetchAssessmentResultError(error.message || 'Failed to fetch assessment result'));
    throw error;
  }
};
